import { ConsultationStatus } from '@/shared/api/transcriptor/transcriptorApi';

/**
 * Matches an inline literature citation marker such as `[11]` or `[9, 11-13]`.
 * Captures the comma/space/dash-separated citation numbers inside the brackets.
 */
export const CITATION_PATTERN = /\[(\d+(?:[,\s-]+\d+)*)\]/g;

/** Splits captured citation numbers while keeping the separators between them. */
export const CITATION_NUMBER_SEPARATOR = /([,\s-]+)/;

export const COPY_SUCCESS_DURATION = 2000;

export const FALLBACK_TAB_VALUE = 'summary';

/** Terminal statuses a recording can be continued from; in-progress ones would race the pipeline. */
export const CONTINUABLE_STATUSES: ConsultationStatus[] = [
  'succeeded',
  'failed',
];
